/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  ButtonBase,
  Divider,
  Fade,
  Typography
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect } from 'react'

import { CounterWithLabel } from '../../../../components/CounterWithLabel'
import { DateRangePicker } from '../../../../components/DatePicker/DateRangePicker'
import { formatShortDateWithWeekDay } from '../../../../helpers/date'
import { SITE_KEY } from '../../../../helpers/elements'
import { getTranslate, lang } from '../../../../localization'
import calculateRangeOfDays from '../../CalculateRangeOfDays'
import convertDate from '../../ConvertDate'
import SearchWidgetArrivalDate from '../../SearchWidgetArrivalDate'
import SearchWidgetDepartureDate from '../../SearchWidgetDepartureDate'
import SearchWidgetGuests from '../../SearchWidgetGuests'
import SearchWidgetSearchInput from '../../SearchWidgetSearchInput'
import { SearchWidgetProps } from '../SearchWidgetProps'
import useStyles from './SearchWidgetMobileInterface.styles'

const SearchWidgetMobileInterface: React.FC<SearchWidgetProps> = ({
  selectRangeModalIsOpen,
  setSelectRangeModalIsOpen,
  selectNumberOfGuestsModalIsOpen,
  setSelectNumberOfGuestsModalIsOpen,
  dateObject,
  setdateObject,
  guestsNumber,
  setguestsNumber,
  datePickerRef,
  effectFunction,
  guestInfoRef,
  type,
  searchAvailabilityInput,
  setSearchAvailabilityInput,
  options,
  bookingRedirect,
  isFromBooking,
  readMode,
  setreadMode,
  loadingForWBSData,
  setBookingRedirect,
  selectingStartDate,
  setSelectingStartDate
}) => {
  useEffect(
    () => effectFunction(),
    [
      datePickerRef,
      selectRangeModalIsOpen,
      selectNumberOfGuestsModalIsOpen,
      guestInfoRef
    ]
  )
  const classes = useStyles()
  const nowDate = new Date()

  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const range =
    dateObject && dateObject.gregorianStartDate && dateObject.gregorianEndDate
      ? calculateRangeOfDays(
          dateObject && dateObject.gregorianStartDate
            ? dateObject.gregorianStartDate
            : `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`,

          dateObject && dateObject.gregorianEndDate
            ? dateObject.gregorianEndDate
            : `${tomorrow.getFullYear()}-${tomorrow.getMonth()}-${tomorrow.getDate()}`
        )
      : 1

  const selectedDestination = options.find((item) => {
    if (searchAvailabilityInput && searchAvailabilityInput.cityID) {
      return item.cityID === searchAvailabilityInput.cityID
    } else if (
      searchAvailabilityInput &&
      searchAvailabilityInput.propertyCode
    ) {
      return item.destinationCode === searchAvailabilityInput.propertyCode
    }
  })
  const handleSearch = () => {
    const siteKey = SITE_KEY
    let url = ''
    if (isFromBooking) {
      const initialReferer = localStorage.getItem('Referer')
      url = `${bookingRedirect}/${
        searchAvailabilityInput.cityID ? 'city' : 'hotel'
      }/?filter=${encodeURIComponent(
        JSON.stringify(searchAvailabilityInput)
      )}&site-key=${encodeURIComponent(
        siteKey || ''
      )}&initial-referer=${encodeURIComponent(initialReferer || '')}`
    } else {
      url = `${bookingRedirect}/${
        searchAvailabilityInput.cityID ? 'city' : 'hotel'
      }/?filter=${encodeURIComponent(
        JSON.stringify(searchAvailabilityInput)
      )}&site-key=${encodeURIComponent(siteKey || '')}`
    }

    window.location.href = url
  }

  const disabled = !(
    (searchAvailabilityInput.propertyCode ||
      !!searchAvailabilityInput.cityID) &&
    !!dateObject.gregorianEndDate
  )

  if (readMode) {
    return (
      <div className={classes.readMode}>
        <div
          className={classes.searchContainer}
          onClick={() => {
            setreadMode(false)
          }}>
          <SearchIcon className={classes.icon} />
        </div>
        <div className={classes.details}>
          <Typography variant="h4" className={classes.title2}>
            {selectedDestination?.destinationName}
          </Typography>
          <div className={classes.row}>
            <Typography variant="h6" className={classes.title}>
              {`${
                searchAvailabilityInput.arrival &&
                formatShortDateWithWeekDay(
                  searchAvailabilityInput.arrival,
                  lang
                )
              } - ${
                searchAvailabilityInput.departure &&
                formatShortDateWithWeekDay(
                  searchAvailabilityInput.departure,
                  lang
                )
              } ${getTranslate(',')} ${
                searchAvailabilityInput.guestsAges.length
              } ${getTranslate('Travelers')}${getTranslate(
                ','
              )} 1 ${getTranslate('Room')} ${getTranslate(
                'and'
              )} ${range} ${getTranslate('Nights')}`}
            </Typography>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={[classes.root, !isFromBooking && classes.root2].join(' ')}>
      <div>
        <SearchWidgetSearchInput
          options={options}
          loadingForWBSData={loadingForWBSData}
          searchAvailabilityInput={searchAvailabilityInput}
          setSearchAvailabilityInput={setSearchAvailabilityInput!}
          setBookingRedirect={setBookingRedirect}
        />
      </div>
      <div className={classes.separator} />
      <div className={classes.dateModalContainer}>
        <div
          role="presentation"
          onClick={() => {
            setSelectRangeModalIsOpen(!selectRangeModalIsOpen)
            setSelectingStartDate(true)
          }}>
          <SearchWidgetArrivalDate
            data={convertDate(
              dateObject && dateObject.gregorianStartDate
                ? dateObject.gregorianStartDate
                : `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`
            )}
            selectingStartDate={selectingStartDate}
          />
        </div>
        <Divider orientation="vertical" className={classes.columnSeparator} />
        <div
          role="presentation"
          onClick={() => {
            setSelectRangeModalIsOpen(!selectRangeModalIsOpen)
            setSelectingStartDate(false)
          }}>
          <SearchWidgetDepartureDate
            data={convertDate(
              dateObject && dateObject.gregorianEndDate
                ? dateObject.gregorianEndDate
                : undefined
              // : `${tomorrow.getFullYear()}-${tomorrow.getMonth()}-${tomorrow.getDate()}`
            )}
            selectingStartDate={selectingStartDate}
          />
        </div>
      </div>
      <div className={classes.separator} />
      <div
        role="presentation"
        onClick={() => setSelectNumberOfGuestsModalIsOpen(true)}>
        <SearchWidgetGuests guestsNumber={guestsNumber} />
        {selectNumberOfGuestsModalIsOpen && (
          <Fade in={selectNumberOfGuestsModalIsOpen} timeout={500}>
            <div className={classes.guestModal} ref={guestInfoRef}>
              <CounterWithLabel
                label={getTranslate('Adult')}
                value={guestsNumber}
                setValue={setguestsNumber}
                max={5}
                min={1}
              />
            </div>
          </Fade>
        )}
      </div>
      <div className={classes.searchButtonContianer}>
        <ButtonBase className={classes.buttonBase} disabled={disabled}>
          <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            fullWidth
            className={classes.searchButton}
            onClick={() => {
              setreadMode(true)
              handleSearch()
            }}
            endIcon={<SearchIcon className={classes.searchIcon} />}>
            <Typography className={classes.btnText}>
              {getTranslate('Search')}
            </Typography>
          </Button>
        </ButtonBase>
        {selectRangeModalIsOpen && (
          <Fade in={selectRangeModalIsOpen} timeout={500}>
            <div className={classes.dateModal} ref={datePickerRef}>
              <div className={classes.nightContainer}>
                <div>
                  <Typography variant="h3" color="secondary">
                    {range}
                  </Typography>
                </div>
                &nbsp;
                <div>
                  <Typography variant="h4" color="secondary">
                    {getTranslate('nights')}
                  </Typography>
                </div>
              </div>
              <DateRangePicker
                onChange={(date) => {
                  setdateObject(date)
                }}
                dateObject={dateObject}
                type={type}
                onDoneClicked={(event) => {
                  event.stopPropagation()
                  setSelectRangeModalIsOpen(false)
                }}
                selectingStart={selectingStartDate}
                setSelectingStart={setSelectingStartDate}
              />
            </div>
          </Fade>
        )}
      </div>
    </div>
  )
}
export default SearchWidgetMobileInterface
